export class InstantJson {
  public readonly format = 'https://pspdfkit.com/instant-json/v1';

  constructor(public readonly annotations) {}
}
